export default {"src":"/_next/static/media/Step4.48df849d.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};